function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';

var Price = function Price(_ref) {
  var amount = _ref.amount,
      className = _ref.className,
      mention = _ref.mention,
      period = _ref.period,
      showCents = _ref.showCents,
      others = _objectWithoutProperties(_ref, ["amount", "className", "mention", "period", "showCents"]);

  var classes = classNames('price', className);
  var isNegative = amount < 0;
  var absoluteAmount = Math.abs(amount); // Math.floor on negative decimal decrease its value (as expected), ex: Math.floor(-17.09) => -18
  // Use of Math.abs prevent this in our case

  var absoluteWhole = Math.floor(absoluteAmount);
  var whole = isNegative ? -absoluteWhole : absoluteWhole; // Floating point problem Math.floor gives inconsistent results with decimals,
  // Math.round prevents it and is enough with prices decimals
  // ex: (17.09 - 17) * 100 = 8.999999999999986 > Floating point problem
  // ex: Math.round((17.09 - 17) * 100) = 9 > Expected result
  // For more informations https://floating-point-gui.de/

  var cents = Math.floor(Math.round((absoluteAmount - absoluteWhole) * 100)).toString().padStart(2, '0');
  return React.createElement("div", _extends({
    className: classes
  }, others), React.createElement("p", {
    className: "main"
  }, whole), React.createElement("span", {
    className: "price-details"
  }, React.createElement("span", {
    className: "centimes"
  }, "\u20AC", showCents && cents, mention && React.createElement("sup", null, mention)), period && React.createElement("span", {
    className: "periode"
  }, "/", period)));
};

Price.propTypes = {
  className: PropTypes.string,
  amount: PropTypes.number.isRequired,
  mention: PropTypes.string,
  period: PropTypes.string,
  showCents: PropTypes.bool
};
Price.defaultProps = {
  showCents: true
};
export default withModifiers(Price);